import React, {ReactText, FC} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {EMetaActionType, selectMetadata} from 'entities/metadata';
import {selectEntityData} from 'modules/data';
import {createActionGetFile, createActionHandlerDownloadFile} from 'modules/data/data-actions';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {ERequestType} from 'shared/types/requests';
import {useAppSelector} from 'store/config/hooks';
import {TAppState} from 'store/config/types';

import {ActionButton} from '../action-button';
import {ITableActionProps} from '../table-action-types';

const ButtonActionForDownloadFileRowsComponent: FC<ITableActionProps> = ({
    wrapper,
    meta,
    entityName,
    ...props
}: ITableActionProps) => {
    const referenceUrl = meta?.referenceUrl || entityName;
    const {requestType} = meta;
    const {urlConfig} = useAppSelector(selectMetadata(entityName, EEntityType.TABLE)) || {};
    const tableData = useSelector((state: TAppState) => (
        selectEntityData(entityName, EEntityType.TABLE)(state) || {}) as ITableEntityData);
    const {selectedRowKeys = []} = tableData || {};
    const dispatch = useDispatch();
    const actionsForRows = (ids: ReactText[]) => {
        if (meta.actionType === EMetaActionType.DOWNLOAD_TABLE_ROWS) {
            const newUrl = `${referenceUrl}?${selectedRowKeys.map(id => `ids=${id}`).join('&')}`;
            if (requestType && requestType === ERequestType.GET) {
                dispatch(createActionGetFile({referenceUrl: newUrl, requestType}));
                return;
            }
            dispatch(
                createActionHandlerDownloadFile(
                    entityName,
                    referenceUrl,
                    ERequestType.POST,
                    {ids},
                    meta?.shouldIgnoreUrlConfig ? undefined : urlConfig,
                ),
            );
        }
        /* else if (meta.actionType === MetaActionType.DOWNLOAD_MULTIPLE_TABLE_ROWS) {
            if (requestType && requestType === RequestType.GET) {
                selectedRows.forEach(row => {
                    if (row?.attachmentIds && Array.isArray(row?.attachmentIds)) {
                        row?.attachmentIds.forEach(id => {
                            dispatch(createActionGetFile({
                                referenceUrl: `${referenceUrl}/${id}`,
                                requestType,
                                urlConfig: meta?.shouldIgnoreUrlConfig ? undefined : urlConfig,
                            }));
                        });
                    }
                });
            }
        } */
    };
    const handleClick = () => {
        actionsForRows(selectedRowKeys);
    };
    const Component = wrapper || ActionButton;

    return (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={meta.actionIcon}
            disabled={!selectedRowKeys.length}
        >
            {meta.actionTitle}
        </Component>
    );
};

export const ButtonActionForDownloadFileRows = ButtonActionForDownloadFileRowsComponent;
